import React from "react"

const WritingModule = () => (
    <section class="lrws-section-1">
        <div class="container">
        <div class="listening-wrapper mt-5">
              <div class="row">
                <div class="col-md-4">
                  <div class="listening-image-wrapper">
                    <img src={require('../../images/writing-image.png')} alt="" />
                  </div>
                </div>
                <div class="col-md-8" >
                  <div class="listening-content-wrapper">
                    <h3 class="content-title">
                      Writing
                    </h3>
                    <ul>
                      <li>
                        <span>
                          <img src={require('../../images/duration.png')} alt="" />
                          <strong>Duration : </strong> 60 min (20 min & 40 min)
                        </span>
                      </li>
                    </ul>
                    <div class="listening-sections-wrapper">
                      <p class="content-sub-title pb-0">Sections</p>
                      <p className="note">The listening part has four sections. </p>
                      <div class="content-sections">
                        <div>Task 1</div>
                        <p>Describe given visual information (graph/table/chart/diagram) in 150 words.</p>
                      </div>
                      <div class="content-sections">
                        <div>Task 2</div>
                        <p>Write an essay (250 words) in response to a point of view, argument or problem.</p>
                      </div>
                    </div>
                    <p class="content-disclaimer" style={{color: '#000'}}><strong>Scoring scale:</strong> <span style={{fontSize: '15px'}}>0-9 brands</span></p>
                    <div class="d-flex align-items-center">
                      <button class="trymock-btn">TRY MOCK TEST</button>
                      <div class="free-label">FREE!</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
)

export default WritingModule
